import React from "react";
import { createRoot } from "react-dom/client";
import { Amplify } from 'aws-amplify';
import awsExports from "./aws-exports";
import AppRouter from "./AppRouter";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.scss";

//Amplify.configure(awsconfig);
Amplify.configure({
  
  Auth: {
    region: awsExports.aws_project_region,
    userPoolId: awsExports.aws_user_pools_id,
    userPoolWebClientId: awsExports.aws_user_pools_web_client_id,
    identityPoolId: awsExports.aws_cognito_identity_pool_id,
    oauth: {
      domain: awsExports.oauth.domain,
      scope: ["email", "openid", "aws.cognito.signin.user.admin", "profile"],
      redirectSignIn:
        process.env.REACT_APP_redirectSignIn || "http://localhost:3000/",
      redirectSignOut: process.env.REACT_APP_redirectSignIn,
      responseType: "code",
    },
  },
  API: {
    aws_appsync_graphqlEndpoint: awsExports.aws_appsync_graphqlEndpoint,
    aws_appsync_region: awsExports.aws_appsync_region,
    aws_appsync_authenticationType: awsExports.aws_appsync_authenticationType,
    endpoints: [
      {
        name: awsExports.aws_cloud_logic_custom[0].name,
        endpoint: awsExports.aws_cloud_logic_custom[0].endpoint,
        region: awsExports.aws_cloud_logic_custom[0].region,
      },
    ],
  },
});
console.log(Amplify.API);
const root = createRoot(document.getElementById("root"));
root.render(<AppRouter />);
